// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chat window skeleton */
.roq-skeleton-box.roq-chat-message-list-loader {
  color: transparent;
  display: flex;
  flex-direction: column;
  padding: var(--spacing-small);
}

.roq-chat-message-skeleton {
  display: flex;
  gap: var(--spacing-small);
  padding-bottom: var(--spacing-large);
}

.roq-chat-message-skeleton__avatar {
  background-color: var(--color-background-skeleton);
  border-radius: var(--border-radius-tiny);
  height: var(--size-avatar);
  width: var(--size-avatar);
}

.roq-chat-message-skeleton__content {
  max-width: 80%;
  width: var(--size-message-skeleton);
}

.roq-chat-message-skeleton__content__message {
  /* 
    @todo Until ROQ guys remove lorem ipsum text from skeleton <div/>
    this solution will fix bug with showing unwanted text.
    When lorem ipsum text is removed, we can delete 
    color: transparent; and user-select: none;
  */
  color: transparent;
  padding: var(--spacing-small);
  user-select: none;
}

.roq-chat-message-skeleton__content__time {
  display: none;
}

/* Chat conversations list skeleton */

.roq-skeleton-box.roq-chat-member-list-loader,
.roq-skeleton-box.roq-chat-conversation-list-loader {
  display: flex;
  flex-direction: column;
  gap: calc(var(--spacing-small) * 2);
  margin-top: var(--spacing-small);
}

.roq-chat-member-item-skeleton,
.roq-chat-conversation-card-skeleton {
  height: var(--size-avatar);
  margin: 0 var(--spacing-small) 0 var(--spacing-small);
}

/* Skeleton animation */

@keyframes roq-shine {
  from {
    background-position-x: -20%;
  }

  to {
    background-position-x: 120%;
  }
}

.roq-chat-member-item-skeleton,
.roq-chat-conversation-card-skeleton,
.roq-chat-message-skeleton__avatar,
.roq-chat-message-skeleton__content__message,
.roq-chat-message-skeleton__content__time {
  animation: roq-shine var(--preference-transition-duration-long) linear
    infinite;
  background-color: var(--color-background-skeleton);
  background-image: linear-gradient(
    115deg,
    var(--color-transparent),
    var(--color-background),
    var(--color-transparent)
  );
  background-repeat: no-repeat;
  background-size: 20% 100%;
  border-radius: var(--border-radius-huge);
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/roqChat/_skeletons.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,kDAAkD;EAClD,wCAAwC;EACxC,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE;;;;;GAKC;EACD,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA,qCAAqC;;AAErC;;EAEE,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;;EAEE,0BAA0B;EAC1B,qDAAqD;AACvD;;AAEA,uBAAuB;;AAEvB;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;;;;;EAKE;YACU;EACV,kDAAkD;EAClD;;;;;GAKC;EACD,4BAA4B;EAC5B,yBAAyB;EACzB,wCAAwC;AAC1C","sourcesContent":["/* Chat window skeleton */\n.roq-skeleton-box.roq-chat-message-list-loader {\n  color: transparent;\n  display: flex;\n  flex-direction: column;\n  padding: var(--spacing-small);\n}\n\n.roq-chat-message-skeleton {\n  display: flex;\n  gap: var(--spacing-small);\n  padding-bottom: var(--spacing-large);\n}\n\n.roq-chat-message-skeleton__avatar {\n  background-color: var(--color-background-skeleton);\n  border-radius: var(--border-radius-tiny);\n  height: var(--size-avatar);\n  width: var(--size-avatar);\n}\n\n.roq-chat-message-skeleton__content {\n  max-width: 80%;\n  width: var(--size-message-skeleton);\n}\n\n.roq-chat-message-skeleton__content__message {\n  /* \n    @todo Until ROQ guys remove lorem ipsum text from skeleton <div/>\n    this solution will fix bug with showing unwanted text.\n    When lorem ipsum text is removed, we can delete \n    color: transparent; and user-select: none;\n  */\n  color: transparent;\n  padding: var(--spacing-small);\n  user-select: none;\n}\n\n.roq-chat-message-skeleton__content__time {\n  display: none;\n}\n\n/* Chat conversations list skeleton */\n\n.roq-skeleton-box.roq-chat-member-list-loader,\n.roq-skeleton-box.roq-chat-conversation-list-loader {\n  display: flex;\n  flex-direction: column;\n  gap: calc(var(--spacing-small) * 2);\n  margin-top: var(--spacing-small);\n}\n\n.roq-chat-member-item-skeleton,\n.roq-chat-conversation-card-skeleton {\n  height: var(--size-avatar);\n  margin: 0 var(--spacing-small) 0 var(--spacing-small);\n}\n\n/* Skeleton animation */\n\n@keyframes roq-shine {\n  from {\n    background-position-x: -20%;\n  }\n\n  to {\n    background-position-x: 120%;\n  }\n}\n\n.roq-chat-member-item-skeleton,\n.roq-chat-conversation-card-skeleton,\n.roq-chat-message-skeleton__avatar,\n.roq-chat-message-skeleton__content__message,\n.roq-chat-message-skeleton__content__time {\n  animation: roq-shine var(--preference-transition-duration-long) linear\n    infinite;\n  background-color: var(--color-background-skeleton);\n  background-image: linear-gradient(\n    115deg,\n    var(--color-transparent),\n    var(--color-background),\n    var(--color-transparent)\n  );\n  background-repeat: no-repeat;\n  background-size: 20% 100%;\n  border-radius: var(--border-radius-huge);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
